export const CHANGE_BACKGROUND_COLOR = 'Change Background Color';
export const CHANGE_BACKGROUND_IMAGE = 'Change Background Image';
export const CHANGE_BACKGROUND_SPACE = 'Change Background Space';
